import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const projectContributionApi = generateNomenApi(`/nomen/project-contributions`);

export const projectContributionOptions = generateNomenOptions('projectContribution', projectContributionApi);
